export default "__VITE_ASSET__2ee541d3__"